import moment from "moment";
import { Task } from "../../Constants/objectTypes";
import {
  ADD_TASK,
  SET_TASKS,
  DELETE_TASK,
  UNDO_DELETE_TASK,
} from "../../Constants/reducerEvents";
import { deleteTask, updateTask } from "../../Endpoints";

const INITIAL_STATE: Task[] = [];
export default function taskReducer(
  state: Task[] = INITIAL_STATE,
  action: { type: string; payload: any }
) {
  switch (action.type) {
    case SET_TASKS:
      return action.payload;
    case ADD_TASK:
      updateTask(action.payload);
      if (state.some((t) => t.id === action.payload.id)) {
        console.log("Current state", state);
        return state.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        });
      }
      console.log("not");

      return [...state, action.payload];
    case DELETE_TASK:
      deleteTask(action.payload);
      return state.filter((t) => t.id !== action.payload);
    case UNDO_DELETE_TASK:
      return state.map((t) => {
        if (t.id === action.payload) {
          const newTask = {
            ...t,
            complete: false,
            completeTime: null,
          };
          updateTask(newTask);
          return newTask;
        }
        return t;
      });
    default:
      return state;
  }
}
